

// var BASE_URL = 'https://api.exhaustexpert.com';

window.state = window.state || {};
window.state.vinScannerOpen = window.state.vinScannerOpen || false;
window.state.vinInput = window.state.vinInput || '';
window.state.vinError = window.state.vinError || '';
window.state.vinDecodeError = window.state.vinDecodeError || '';
// Renders modal HTML into the page
function patchVinModal() {
  const modalRoot = document.getElementById('vin-modal-root');
  if (!modalRoot) return;
  if (state.vinScannerOpen) {
    modalRoot.innerHTML = renderVinScannerModal();
  } else {
    modalRoot.innerHTML = '';
  }
}

// Called by scanVin.js after successful scan
function decodeVin(vin) {
  const input = document.getElementById('vinInput');
  if (input) input.value = vin;
  lookupVIN();
}

// Toast notifications used by scanVin.js
function showToast(msg) {
  let toast = document.getElementById('vin-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'vin-toast';
    toast.style.cssText = 'position:fixed;bottom:30px;left:50%;transform:translateX(-50%);background:#1D4064;color:#fff;padding:12px 24px;border-radius:8px;z-index:9999;font-size:15px;pointer-events:none;';
    document.body.appendChild(toast);
  }
  toast.textContent = msg;
  toast.style.display = 'block';
  clearTimeout(toast._t);
  toast._t = setTimeout(() => { toast.style.display = 'none'; }, 3000);
}

// VIN validation used by scanVin.js
function normalizeVin(vin) {
  if (!vin) return null;
  const v = String(vin).toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');
  if (v.length !== 17) return null;
  if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(v)) return null;
  return v;
}

// waitForElement so openVinScanner doesn't fire before DOM is ready
function waitForElement(id, timeoutMs) {
  return new Promise((resolve, reject) => {
    const el = document.getElementById(id);
    if (el) return resolve(el);
    const interval = setInterval(() => {
      const found = document.getElementById(id);
      if (found) {
        clearInterval(interval);
        clearTimeout(timeout);
        resolve(found);
      }
    }, 50);
    const timeout = setTimeout(() => {
      clearInterval(interval);
      reject(new Error('#' + id + ' not found after ' + timeoutMs + 'ms'));
    }, timeoutMs);
  });
}


window.handleCategoryChange = async function () {
  const categorySelect    = document.getElementById('categorySelect');
  const subcategoryGroup  = document.getElementById('subcategoryGroup');
  const subcategorySelect = document.getElementById('subcategorySelect');

  subcategorySelect.innerHTML = '<option value="">Select a Subcategory</option>';
  subcategoryGroup.style.display = 'none';
  window.activeSubCategoryID = '';

  const categoryId = categorySelect.value;
  if (!categoryId) return;

  try {
    const res  = await fetch(`https://data.usconvertors.com/search.php?action=get_subcategories&category_id=${encodeURIComponent(categoryId)}`);
    const data = await res.json();
    if (data.success && data.data.length > 0) {
      data.data.forEach(function (item) {
        const opt       = document.createElement('option');
        opt.value       = item.id;
        opt.textContent = item.options;
        subcategorySelect.appendChild(opt);
      });
      subcategoryGroup.style.display = 'inline-block';
    }
  } catch (err) {
    console.error('Error fetching subcategories:', err);
  }
};

window.handleSubcategoryChange = function () {
  window.activeSubCategoryID = document.getElementById('subcategorySelect').value;
};

function switchToTab(tabId) {
  const tabTitles = document.querySelectorAll('.tab-title');
  tabTitles.forEach(tab => tab.classList.remove('active'));
 
  const tabPanes = document.querySelectorAll('.tab-pane');
  tabPanes.forEach(pane => pane.classList.remove('active'));
 
  const selectedTab = document.querySelector(`.tab-title[data-tab="${tabId}"]`);
  if (selectedTab) {
      selectedTab.classList.add('active');
  }
 
  const selectedPane = document.getElementById(tabId);
  if (selectedPane) {
      selectedPane.classList.add('active');
  }
}
 
function populateDropdown(dropdownId, value) {
  const dropdown = document.getElementById(dropdownId);
  if (dropdown) {
      dropdown.innerHTML = '';
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = true;
      dropdown.appendChild(option);
  }
}
 
function populateModelDropdown(dropdownId, value) {
  const dropdown = document.getElementById(dropdownId);
  if (dropdown) {
      dropdown.innerHTML = '';
      const option = document.createElement('option');
      option.value = value;
      option.textContent = value;
      option.selected = true;
      dropdown.appendChild(option);
      handleModelChange();
  }
}

async function lookupVIN() {
//   const vin = document.getElementById('vinInput').value;
//   const resultDiv = document.getElementById('results');
 const vinInput =
    document.getElementById('cp-vin-input') ||
    document.getElementById('vinInput');

  if (!vinInput) {
    console.error('VIN input element not found');
    return;
  }

  const vin = vinInput.value;

  const resultDiv = document.getElementById('results');
  resultDiv.textContent = 'Loading...';

  try {
    const response = await fetch('https://data.usconvertors.com/vin-lookup.php?vin=' + encodeURIComponent(vin));
    
    if (!response.ok) {
        throw new Error('Network response was not ok: ' + response.statusText);
    }
    
    const data = await response.json();
    console.log(JSON.stringify(data, null, 2));
    console.log(data);
    
    if (data) {
        const year = data.ModelYear || 'N/A';
        const make = data.Make || 'N/A';
        const model = data.Model || 'N/A';
        const trim = data.Trim || 'N/A';
    
        console.log(`Year: ${year}`);
        console.log(`Make: ${make}`);
        console.log(`Model: ${model}`);
        console.log(`Trim: ${trim}`);
    
        resultDiv.textContent = `Year: ${year}, Make: ${make}, Model: ${model}, Trim: ${trim}`;

        switchToTab('tab1');

        populateDropdown('yearSelect', year);
        populateDropdown('makeSelect', make);
        populateModelDropdown('modelSelect', model);
        
    } else {
        console.log('Results is not an object or is missing.');
        resultDiv.textContent = 'Results is not in the expected format.';
    }
    
  } catch (error) {
      console.error('Fetch error:', error);
      resultDiv.textContent = 'An error occurred: ' + error.message;
  }
}
 
window.addEventListener('load', function () {
  if (typeof ZXing === 'undefined') return;
  let selectedDeviceId;
  const codeReader = new ZXing.BrowserMultiFormatReader()
  console.log('ZXing code reader initialized')
  codeReader.listVideoInputDevices()
    .then((videoInputDevices) => {
      const sourceSelect = document.getElementById('sourceSelect')
      selectedDeviceId = videoInputDevices[0].deviceId
      if (videoInputDevices.length >= 1) {
        videoInputDevices.forEach((element) => {
          const sourceOption = document.createElement('option')
          sourceOption.text = element.label
          sourceOption.value = element.deviceId
          sourceSelect.appendChild(sourceOption)
        })
  
        sourceSelect.onchange = () => {
          selectedDeviceId = sourceSelect.value;
        };
  
        const sourceSelectPanel = document.getElementById('sourceSelectPanel')
      }
  
      document.getElementById('startButton').addEventListener('click', () => {
        codeReader.decodeFromVideoDevice(selectedDeviceId, 'video', (result, err) => {
          if (result) {
            console.log(result)
            document.getElementById('vinInput').value = result.text
            lookupVIN();
            codeReader.reset()
          }
          if (err && !(err instanceof ZXing.NotFoundException)) {
            console.error(err)
            document.getElementById('vinInput').textContent = err
          }
        })
        console.log(`Started continous decode from camera with id ${selectedDeviceId}`)
      })
  
      document.getElementById('resetButton').addEventListener('click', () => {
        codeReader.reset()
        document.getElementById('vinInput').value = '';
        console.log('Reset.')
      })
  
    })
    .catch((err) => {
      console.error(err)
    })
})


var resultsContainer = document.getElementById('results');
var loadingSpinner = document.getElementById('loading');
document.getElementById('cross-search').addEventListener('input', function() {
    let searchTerm = this.value.trim();

    if (searchTerm.length < 3) {
        resultsContainer.innerHTML = '<div id="loading" class="spinner"></div>';
        return;
    }

    loadingSpinner.style.display = 'block';

    fetch(`https://data.usconvertors.com/crossreference.php?term=${encodeURIComponent(searchTerm)}`)
    // fetch(`${BASE_URL}/vehicle/product-search?term=${encodeURIComponent(searchTerm)}`)
        .then(response => response.json())
        .then(data => {
            displayResults(data);
        })
        .catch(error => {
            console.error('Error fetching results:', error);
            resultsContainer.innerHTML = 'Error fetching results.';
        })
        .finally(() => {
            loadingSpinner.style.display = 'none';
        });
});

function displayResults(parts) {
    if (!parts || parts.length === 0) {
        resultsContainer.innerHTML = `
            <div style="text-align:center;padding:40px;color:#888">
                <p style="font-weight:600">No parts found</p>
                <p style="font-size:14px">Try different filters</p>
            </div>`;
        return;
    }

    // Normalize parts so openYmmPartDetail gets correct fields
    window._vehicleParts = parts.map(p => ({
        part:       p.part || p.partNumber || p.sku || p.name || '',
        partNumber: p.part || p.partNumber || p.sku || p.name || '',
        image:      p.image || p.imageUrl || null,
        price:      p.price != null ? parseFloat(p.price) : null,
        stock:      p.stock != null ? parseInt(p.stock) : null,
        summary:    p.summary || p.notes || null,
        vendor:     p.vendor || p.brand || null,
        handle:     p.handle || null,
        qual:       p.qual || null,
    }));

    const esc = (str) => String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

    const resultsHtml = window._vehicleParts.map((part, idx) => {
        const price = part.price != null ? part.price.toFixed(2) : null;
        const stock = part.stock;

        return `
            <div class="result-item" style="cursor:pointer;padding:16px"
                 onclick="openYmmPartDetail(${idx})">
                <div style="display:flex;gap:14px;align-items:flex-start">
                    <div style="width:72px;height:72px;border-radius:8px;background:#f3f4f6;flex-shrink:0;overflow:hidden">
                        ${part.image
                            ? `<img src="${esc(part.image)}" style="width:100%;height:100%;object-fit:cover">`
                            : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#9ca3af">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                                    <circle cx="8.5" cy="8.5" r="1.5"/>
                                    <path d="M21 15l-5-5L5 21"/>
                                </svg>
                               </div>`
                        }
                    </div>
                    <div style="flex:1;min-width:0">
                        <p style="font-weight:600;font-size:15px;color:#1D4064;margin:0 0 4px 0;line-height:1.3">
                            ${esc(part.part)}
                        </p>
                        ${part.vendor ? `<p style="font-size:12px;color:#6b7280;margin:0 0 6px 0">Brand: ${esc(part.vendor)}</p>` : ''}
                        <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">
                            ${price != null ? `<span style="font-size:16px;font-weight:700;color:#1D4064">$${price}</span>` : ''}
                            ${stock != null
                                ? `<span style="font-size:12px;color:${stock > 0 ? '#1d9e75' : '#e24b4a'}">
                                       ${stock > 0 ? `${stock} in stock` : 'Out of stock'}
                                   </span>`
                                : ''}
                        </div>
                        ${part.qual ? `<p style="font-size:12px;color:#6b7280;margin:4px 0 0">Qualifier: ${esc(part.qual)}</p>` : ''}
                        ${part.summary
                            ? `<p style="font-size:13px;color:#6b7280;line-height:1.4;margin-top:8px;
                                        display:-webkit-box;-webkit-line-clamp:2;
                                        -webkit-box-orient:vertical;overflow:hidden">
                                   ${esc(part.summary)}
                               </p>`
                            : ''}
                    </div>
                    <div style="color:#9ca3af;flex-shrink:0;align-self:center">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="9 18 15 12 9 6"/>
                        </svg>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    resultsContainer.innerHTML = `
        <div class="results-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:16px">
            ${resultsHtml}
        </div>`;
    document.getElementById('results-header').style.display = 'block';
}

document.getElementById('search').addEventListener('input', function() {
    let searchTerm = this.value.trim();

    if (searchTerm.length < 3) {
        resultsContainer.innerHTML = '<div id="loading" class="spinner"></div>';
        return;
    }

    loadingSpinner.style.display = 'block';

    const token = localStorage.getItem('token');
    
    fetch(`https://api.exhaustexpert.com/vehicle/product-search?term=${encodeURIComponent(searchTerm)}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { 'Authorization': `Bearer ${token}` } : {})
        },
        credentials: 'include'
    })
    .then(response => {
        if (response.status === 401) {
            throw new Error('SESSION_EXPIRED');
        }
        return response.json();
    })
    .then(data => {
        // ✅ Pass searchTerm for exact match filtering
        displayPartSearchResults(data, searchTerm);
    })
    .catch(error => {
        console.error('Error fetching results:', error);
        if (error.message === 'SESSION_EXPIRED') {
            resultsContainer.innerHTML = `
                <div style="text-align:center;padding:40px;color:#e24b4a">
                    <p style="font-weight:600">Session expired</p>
                    <p style="font-size:14px;margin:8px 0">Please <a href="/pages/login" style="color:#4b9e95">login again</a> to continue.</p>
                </div>`;
        } else {
            resultsContainer.innerHTML = 'Error fetching results. Please try again.';
        }
    })
    .finally(() => {
        loadingSpinner.style.display = 'none';
    });
});

function displayPartSearchResults(parts, exactMatchTerm = null) {
    if (!parts || parts.length === 0) {
        resultsContainer.innerHTML = `
            <div style="text-align:center;padding:40px;color:#888">
                <p style="font-weight:600">No parts found</p>
                <p style="font-size:14px">Try a different part number</p>
            </div>`;
        return;
    }

    // Exact match filtering
    let filteredParts = parts;
    if (exactMatchTerm && exactMatchTerm.length >= 6) {
        filteredParts = parts.filter(p => {
            const pn = (p.partNumber || p.sku || p.name || p.title || '').toString().toLowerCase();
            return pn === exactMatchTerm.toLowerCase() || pn.startsWith(exactMatchTerm.toLowerCase() + '-');
        });
        if (filteredParts.length === 0) filteredParts = parts;
    }

    // ── Store parts globally so openYmmPartDetail can access them ──
    window._vehicleParts = filteredParts.map(p => ({
        part:       p.partNumber || p.sku || p.name || p.title || p.handle || 'Part',
        partNumber: p.partNumber || p.sku || p.name || p.title || '',
        image:      p.image || p.imageUrl || null,
        price:      p.price != null ? parseFloat(p.price) : null,
        stock:      p.stock != null ? parseInt(p.stock) : null,
        summary:    p.summary || p.notes || null,
        vendor:     p.vendor || p.brand || null,
        handle:     p.handle || null,
    }));

    const esc = (str) => String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

    const resultsHtml = window._vehicleParts.map((part, idx) => {
        const price = part.price != null ? part.price.toFixed(2) : null;
        const stock = part.stock;

        return `
            <div class="result-item" style="cursor:pointer;padding:16px"
                 onclick="openYmmPartDetail(${idx})">
                <div style="display:flex;gap:14px;align-items:flex-start">
                    <!-- Image -->
                    <div style="width:72px;height:72px;border-radius:8px;background:#f3f4f6;flex-shrink:0;overflow:hidden">
                        ${part.image
                            ? `<img src="${esc(part.image)}" style="width:100%;height:100%;object-fit:cover">`
                            : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#9ca3af">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                                    <circle cx="8.5" cy="8.5" r="1.5"/>
                                    <path d="M21 15l-5-5L5 21"/>
                                </svg>
                               </div>`
                        }
                    </div>
                    <!-- Content -->
                    <div style="flex:1;min-width:0">
                        <p style="font-weight:600;font-size:15px;color:#1D4064;margin:0 0 4px 0;line-height:1.3">
                            ${esc(part.part)}
                        </p>
                        ${part.vendor ? `<p style="font-size:12px;color:#6b7280;margin:0 0 6px 0">Brand: ${esc(part.vendor)}</p>` : ''}
                        <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">
                            ${price != null ? `<span style="font-size:16px;font-weight:700;color:#1D4064">$${price}</span>` : ''}
                            ${stock != null
                                ? `<span style="font-size:12px;color:${stock > 0 ? '#1d9e75' : '#e24b4a'}">
                                       ${stock > 0 ? `${stock} in stock` : 'Out of stock'}
                                   </span>`
                                : ''}
                        </div>
                        ${part.summary
                            ? `<p style="font-size:13px;color:#6b7280;line-height:1.4;margin-top:10px;
                                        display:-webkit-box;-webkit-line-clamp:2;
                                        -webkit-box-orient:vertical;overflow:hidden">
                                   ${esc(part.summary)}
                               </p>`
                            : ''}
                    </div>
                    <!-- Arrow -->
                    <div style="color:#9ca3af;flex-shrink:0;align-self:center">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                            <polyline points="9 18 15 12 9 6"/>
                        </svg>
                    </div>
                </div>
            </div>
        `;
    }).join('');

    resultsContainer.innerHTML = `
        <div class="results-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:16px">
            ${resultsHtml}
        </div>`;
    document.getElementById('results-header').style.display = 'block';
}

function openPartModalFromAttr(el) {
    try {
        const dataPart = el.getAttribute('data-part');
        if (!dataPart) return;
        const part = JSON.parse(decodeURIComponent(dataPart));
        
        // Store in global array so openYmmPartDetail can access it
        window._vehicleParts = window._vehicleParts || [];
        // Add or find existing index
        const label = part.label || part.partNumber || part.sku || part.handle || '';
        let idx = window._vehicleParts.findIndex(p => 
            (p.part || p.partNumber || p.sku || '') === label
        );
        if (idx === -1) {
            // Build a part object compatible with openYmmPartDetail
            window._vehicleParts.push({
                part: label,
                partNumber: label,
                image: part.image || null,
                price: part.price || null,
                stock: part.stock || null,
                summary: part.summary || null,
                vendor: part.vendor || null,
                handle: part.handle || null,
            });
            idx = window._vehicleParts.length - 1;
        }
        openYmmPartDetail(idx);
    } catch (e) {
        console.error('Error opening modal:', e);
        showToast('Could not open details');
    }
}

function openPartModal(part) {
    const item = part;
    if (!item) return;

    // ── Helpers ──
    function stripHtml(html) {
        if (!html) return '';
        return html
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/tr>/gi, '\n')
            .replace(/<\/p>/gi, '\n')
            .replace(/<\/li>/gi, '\n')
            .replace(/<\/td>/gi, ' ')
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    // ── Extract Data ──
    const label = item.partNumber || item.sku || item.name || item.title || 'Part';
    const shopify = item.shopify || item;
    const partNum = item.part || item.part_number || null;
    const vendor = shopify.vendor || item.vendor || item.supplier || null;
    const productType = shopify.productType || item.productType || null;
    const variants = shopify.variants || [];
    const price = variants[0]?.price != null ? parseFloat(variants[0].price) : (item.price != null ? parseFloat(item.price) : null);
    const stock = item.stock != null ? parseInt(item.stock) : item.availableQty != null ? parseInt(item.availableQty) : variants[0]?.inventoryQuantity != null ? parseInt(variants[0].inventoryQuantity) : null;
    const inStock = stock != null && stock > 0;
    const image = shopify.images?.[0]?.src || item.image || null;
    const tags = Array.isArray(shopify.tags || item.tags) ? (shopify.tags || item.tags) : [];
    const bodyHtml = shopify.bodyHtml || shopify.body_html || item.bodyHtml || item.body_html || null;

    // ── Table Parsing ──
    let specsRows = [], interchangeRows = [], rawSpecsTable = null, rawInterchangeTable = null;
    if (bodyHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(bodyHtml, 'text/html');
        const tables = doc.querySelectorAll('table');
        if (tables.length > 0) {
            const specsTable = tables[0];
            rawSpecsTable = specsTable.outerHTML;
            specsTable.querySelectorAll('tr').forEach(tr => {
                const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                if (cells.length >= 2 && (cells[0] || cells[1])) {
                    specsRows.push({ label: cells[0], value: cells[1] });
                }
            });
            const interchangeIdx = bodyHtml.toLowerCase().indexOf('interchange');
            if (interchangeIdx !== -1 && tables.length > 1) {
                for (let i = 1; i < tables.length; i++) {
                    const tbl = tables[i];
                    const tblText = tbl.textContent.toLowerCase();
                    if (tblText.includes('brand') && tblText.includes('part')) {
                        rawInterchangeTable = tbl.outerHTML;
                        tbl.querySelectorAll('tr').forEach(tr => {
                            const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                            if (cells.length >= 2) {
                                interchangeRows.push({ brand: cells[0], partNumber: cells[1] });
                            }
                        });
                        break;
                    }
                }
            }
        }
    }

    function htmlWithoutTables(html) {
        if (!html) return '';
        let out = html.replace(/<table[^>]*>[\s\S]*?<\/table>/gi, '');
        const idx = out.search(/Interchange\s+Data/i);
        return idx !== -1 ? out.slice(0, idx) : out;
    }

    const strippedDesc = bodyHtml ? stripHtml(htmlWithoutTables(bodyHtml)).trim() : '';
    const description = item.summary || item.notes || strippedDesc || '';
    const images = (shopify.images || item.images || []);
    const imageList = images.length > 0 ? images.map(img => typeof img === 'string' ? img : (img.src || img.url || '')) : (image ? [typeof image === 'string' ? image : image.src] : []);

    // ── RENDER BASIC MODAL FIRST ──
    const modal = document.createElement('div');
    modal.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.7);display:flex;align-items:center;justify-content:center;z-index:9999;padding:20px;overflow-y:auto;';

    const esc = (str) => String(str||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

    // Show basic modal immediately
    modal.innerHTML = `
        <div style="background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 8px 32px rgba(0,0,0,0.2);">
            <div style="display:flex;align-items:center;justify-content:space-between;padding:16px 20px;border-bottom:1px solid #eaeef2;background:#FBFBFE">
                <h2 style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1;padding-right:12px">${esc(label)}</h2>
                <button onclick="this.closest('[style*=fixed]').remove()" style="background:none;border:none;cursor:pointer;padding:8px;border-radius:8px;color:#888;display:flex;align-items:center">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6L6 18M6 6l12 18"/></svg>
                </button>
            </div>
            <div style="padding:20px;max-height:70vh;overflow-y:auto">
                ${imageList.length > 0 ? `
                    <div style="width:100%;margin-bottom:16px;position:relative;overflow:hidden;border-radius:12px;background:#f9fafb">
                        <img src="${esc(imageList[0])}" style="width:100%;max-height:280px;object-fit:contain;display:block">
                    </div>
                ` : ''}
                <div style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px">
                    ${partNum ? `<span style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0">Part: ${esc(partNum)}</span>` : ''}
                    ${vendor ? `<span style="font-size:13px;color:#6b7280">Brand: ${esc(vendor)}</span>` : ''}
                    ${productType ? `<span style="font-size:13px;color:#6b7280">Type: ${esc(productType)}</span>` : ''}
                </div>
                ${(price != null || stock != null) ? `
                    <div style="display:grid;grid-template-columns:30% 70%;row-gap:6px;padding:12px 0;border-top:1px solid #f3f4f6;border-bottom:1px solid #f3f4f6;margin:12px 0">
                        ${price != null ? `<span style="font-size:13px;color:#6b7280;align-self:center">Price</span><span style="font-size:14px;font-weight:700;color:#1e3a5f">$${price.toFixed(2)}</span>` : ''}
                        <span style="font-size:13px;color:#6b7280;align-self:center">Availability:</span>
                        ${inStock ? `<span style="font-size:13px;color:#1d9e75;font-weight:600">In stock (${stock})</span>` : `<div><div style="font-size:13px;font-weight:700;color:#e24b4a">Out of Stock 😟</div><div style="font-size:11px;color:#6b7280;margin-top:2px">Part is coming soon.</div></div>`}
                    </div>
                ` : ''}
                ${description ? `<div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6"><h3 style="font-size:15px;font-weight:700;color:#1e3a5f;margin:0 0 8px 0">Details</h3><p style="font-size:14px;color:#6b7280;line-height:1.6;margin:0;white-space:pre-wrap">${esc(description)}</p></div>` : ''}
                ${(specsRows.length > 0) ? `
                    <div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6">
                        <h3 style="font-size:15px;font-weight:700;color:#1e3a5f;margin:0 0 10px 0">Specifications</h3>
                        <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-radius:10px;overflow:hidden">
                            ${specsRows.map((row) => `<tr style="border-bottom:1px solid #1e3a5f"><td style="padding:10px 12px;background:#fff;font-size:14px;color:#374151;font-weight:500;border-right:1px solid #1e3a5f;width:40%">${esc(row.label)}</td><td style="padding:10px 12px;background:#f9fafb;font-size:14px;color:#1e3a5f;font-weight:500">${esc(row.value)}</td></tr>`).join('')}
                        </table>
                    </div>
                ` : ''}
                ${(interchangeRows.length > 0) ? `
                    <div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6">
                        <div style="background:#1e3a5f;padding:12px 16px;border-radius:10px 10px 0 0;text-align:center"><span style="font-size:15px;font-weight:700;color:#fff">Interchange Data</span></div>
                        <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-top:none;border-radius:0 0 10px 10px;overflow:hidden">
                            <tr style="background:#f9fafb;border-bottom:1px solid #1e3a5f"><th style="padding:10px 12px;font-size:14px;font-weight:700;color:#1e3a5f;text-align:left">Brand</th><th style="padding:10px 12px;font-size:14px;font-weight:700;color:#1e3a5f;text-align:left">Part Number</th></tr>
                            ${interchangeRows.map(row => `<tr style="border-bottom:1px solid #e5e7eb"><td style="padding:10px 12px;font-size:14px;color:#374151;font-weight:500;border-right:1px solid #1e3a5f">${esc(row.brand)}</td><td style="padding:10px 12px;font-size:14px;color:#1e3a5f;background:#fff">${esc(row.partNumber)}</td></tr>`).join('')}
                        </table>
                    </div>
                ` : ''}
                ${tags.length > 0 ? `
                    <div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6">
                        <h3 style="font-size:15px;font-weight:700;color:#1e3a5f;margin:0 0 10px 0">Compatibility</h3>
                        <div style="display:flex;flex-wrap:wrap;gap:8px">
                            ${tags.slice(0, 20).map(tag => `<span style="background:#f9fafb;padding:6px 10px;border-radius:8px;border:1px solid #1e3a5f;font-size:13px;color:#1e3a5f">${esc(tag)}</span>`).join('')}
                        </div>
                    </div>
                ` : ''}
            </div>
        </div>
    `;
    
    modal.onclick = function(e) { if (e.target === modal) modal.remove(); };
    document.body.appendChild(modal);

    // ── ASYNC ENRICH ──
    (async function enrichDetails() {
        try {
            console.log('🔍 Enriching details for:', label);
            const token = localStorage.getItem('token');
            
            // 1. Fetch warehouse data
            let warehouseItem = null;
            if (label.length >= 3) {
                try {
                    const wRes = await fetch(
                        `https://api.exhaustexpert.com/vehicle/product-search-warehouse?term=${encodeURIComponent(label)}`,
                        {
                            headers: {
                                'Content-Type': 'application/json',
                                ...(token ? { Authorization: `Bearer ${token}` } : {})
                            },
                            credentials: 'include'
                        }
                    );
                    console.log('📦 Warehouse response status:', wRes.status);
                    if (wRes.ok) {
                        const wData = await wRes.json();
                        console.log('📦 Warehouse data:', wData);
                        const wList = Array.isArray(wData) ? wData : (wData.products || wData.data || []);
                        warehouseItem = wList.find(r => (r.partNumber || '').toLowerCase() === label.toLowerCase()) || wList[0];
                        console.log('✅ Found warehouse item:', !!warehouseItem);
                    }
                } catch (e) {
                    console.warn('⚠️ Warehouse fetch error:', e);
                }
            }

            // 2. Fetch full product data
            let fullProduct = null;
            try {
                const pRes = await fetch(
                    `https://api.exhaustexpert.com/products?search=${encodeURIComponent(label)}&limit=5`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token ? { Authorization: `Bearer ${token}` } : {})
                        },
                        credentials: 'include'
                    }
                );
                console.log('🛍️ Products response status:', pRes.status);
                if (pRes.ok) {
                    const pData = await pRes.json();
                    console.log('🛍️ Products data keys:', Object.keys(pData));
                    const pList = Array.isArray(pData) ? pData : (pData.data || pData.products || []);
                    console.log('🛍️ Products list length:', pList.length);
                    fullProduct = pList.find(p => (p.title || '').toLowerCase() === label.toLowerCase()) || pList[0];
                    console.log('✅ Found full product:', !!fullProduct);
                    if (fullProduct) {
                        console.log('🔑 Full product keys:', Object.keys(fullProduct));
                        console.log('📝 bodyHtml length:', (fullProduct.bodyHtml || fullProduct.body_html || '').length);
                        console.log('🖼️ images count:', fullProduct.images?.length || 0);
                        console.log('🏷️ tags count:', fullProduct.tags?.length || 0);
                    }
                }
            } catch (e) {
                console.warn('⚠️ Products fetch error:', e);
            }

            // 3. Merge and re-render if we got new data
            if (warehouseItem || fullProduct) {
                console.log('✨ Enriching with new data');
                
                const mergedBodyHtml = fullProduct?.bodyHtml || fullProduct?.body_html || warehouseItem?.bodyHtml || bodyHtml || '';
                const mergedImages = fullProduct?.images || warehouseItem?.images || images;
                const mergedVariants = fullProduct?.variants || warehouseItem?.variants || variants;
                const mergedPrice = warehouseItem?.price ?? (mergedVariants[0]?.price ? parseFloat(mergedVariants[0].price) : price);
                const mergedStock = warehouseItem?.stock ?? warehouseItem?.availableQty ?? (mergedVariants[0]?.inventoryQuantity ?? stock);
                const mergedVendor = fullProduct?.vendor || warehouseItem?.vendor || vendor;
                const mergedTags = fullProduct?.tags || warehouseItem?.tags || tags;
                const mergedImage = mergedImages[0]?.src || warehouseItem?.image || image;

                // Re-parse tables
                let finalSpecsRows = [], finalInterchangeRows = [];
                if (mergedBodyHtml) {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(mergedBodyHtml, 'text/html');
                    const tables = doc.querySelectorAll('table');
                    if (tables.length > 0) {
                        tables[0].querySelectorAll('tr').forEach(tr => {
                            const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                            if (cells.length >= 2 && (cells[0] || cells[1])) {
                                finalSpecsRows.push({ label: cells[0], value: cells[1] });
                            }
                        });
                        if (tables.length > 1) {
                            for (let i = 1; i < tables.length; i++) {
                                const tbl = tables[i];
                                if (tbl.textContent.toLowerCase().includes('brand') && tbl.textContent.toLowerCase().includes('part')) {
                                    tbl.querySelectorAll('tr').forEach(tr => {
                                        const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                                        if (cells.length >= 2) {
                                            finalInterchangeRows.push({ brand: cells[0], partNumber: cells[1] });
                                        }
                                    });
                                    break;
                                }
                            }
                        }
                    }
                }

                const finalImageList = mergedImages.length > 0 
                    ? mergedImages.map(img => typeof img === 'string' ? img : (img.src || img.url || ''))
                    : (mergedImage ? [typeof mergedImage === 'string' ? mergedImage : mergedImage.src] : []);

                // Update modal content
                const contentDiv = modal.querySelector('div[style*="padding:20px;max-height:70vh"]');
                if (contentDiv) {
                    let html = '';
                    
                    // Image carousel if multiple
                    if (finalImageList.length > 1) {
                        html += `
                            <div style="width:100%;margin-bottom:16px;position:relative;overflow:hidden;border-radius:12px;background:#f9fafb">
                                <div id="part-img-track" style="display:flex;transition:transform 0.35s cubic-bezier(0.4,0,0.2,1)">
                                    ${finalImageList.map((src, i) => `
                                        <div style="min-width:100%;display:flex;align-items:center;justify-content:center;height:280px">
                                            <img src="${esc(src)}" style="max-width:100%;max-height:280px;object-fit:contain;display:block">
                                        </div>
                                    `).join('')}
                                </div>
                                <div id="part-img-dots" style="display:flex;justify-content:center;gap:6px;margin-top:10px">
                                    ${finalImageList.map((_, i) => `
                                        <button onclick="partImgGoToModal(${i})" id="part-dot-modal-${i}"
                                                style="width:${i===0?'20px':'8px'};height:8px;border-radius:4px;border:none;background:${i===0?'#1D4064':'#d1d5db'};cursor:pointer;padding:0;transition:all 0.25s">
                                        </button>
                                    `).join('')}
                                </div>
                            </div>
                        `;
                    } else if (finalImageList.length === 1) {
                        html += `
                            <div style="width:100%;margin-bottom:16px;position:relative;overflow:hidden;border-radius:12px;background:#f9fafb">
                                <img src="${esc(finalImageList[0])}" style="width:100%;max-height:280px;object-fit:contain;display:block">
                            </div>
                        `;
                    }

                    // Specs table
                    if (finalSpecsRows.length > 0) {
                        html += `
                            <div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6">
                                <h3 style="font-size:15px;font-weight:700;color:#1e3a5f;margin:0 0 10px 0">Specifications</h3>
                                <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-radius:10px;overflow:hidden">
                                    ${finalSpecsRows.map((row) => `
                                        <tr style="border-bottom:1px solid #1e3a5f">
                                            <td style="padding:10px 12px;background:#fff;font-size:14px;color:#374151;font-weight:500;border-right:1px solid #1e3a5f;width:40%">${esc(row.label)}</td>
                                            <td style="padding:10px 12px;background:#f9fafb;font-size:14px;color:#1e3a5f;font-weight:500">${esc(row.value)}</td>
                                        </tr>
                                    `).join('')}
                                </table>
                            </div>
                        `;
                    }

                    // Interchange data
                    if (finalInterchangeRows.length > 0) {
                        html += `
                            <div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6">
                                <div style="background:#1e3a5f;padding:12px 16px;border-radius:10px 10px 0 0;text-align:center"><span style="font-size:15px;font-weight:700;color:#fff">Interchange Data</span></div>
                                <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-top:none;border-radius:0 0 10px 10px;overflow:hidden">
                                    <tr style="background:#f9fafb;border-bottom:1px solid #1e3a5f"><th style="padding:10px 12px;font-size:14px;font-weight:700;color:#1e3a5f;text-align:left">Brand</th><th style="padding:10px 12px;font-size:14px;font-weight:700;color:#1e3a5f;text-align:left">Part Number</th></tr>
                                    ${finalInterchangeRows.map(row => `<tr style="border-bottom:1px solid #e5e7eb"><td style="padding:10px 12px;font-size:14px;color:#374151;font-weight:500;border-right:1px solid #1e3a5f">${esc(row.brand)}</td><td style="padding:10px 12px;font-size:14px;color:#1e3a5f;background:#fff">${esc(row.partNumber)}</td></tr>`).join('')}
                                </table>
                            </div>
                        `;
                    }

                    // Tags
                    if (mergedTags.length > 0) {
                        html += `
                            <div style="margin-top:16px;padding-top:16px;border-top:1px solid #f3f4f6">
                                <h3 style="font-size:15px;font-weight:700;color:#1e3a5f;margin:0 0 10px 0">Compatibility</h3>
                                <div style="display:flex;flex-wrap:wrap;gap:8px">
                                    ${mergedTags.slice(0, 20).map(tag => `<span style="background:#f9fafb;padding:6px 10px;border-radius:8px;border:1px solid #1e3a5f;font-size:13px;color:#1e3a5f">${esc(tag)}</span>`).join('')}
                                </div>
                            </div>
                        `;
                    }

                    // Update only if we have new content
                    if (finalSpecsRows.length > 0 || finalInterchangeRows.length > 0 || mergedTags.length > 0 || finalImageList.length > 1) {
                        contentDiv.innerHTML = html || contentDiv.innerHTML;
                        
                        // Init carousel if needed
                        if (finalImageList.length > 1) {
                            window._partImgCurrentModal = 0;
                            window.partImgGoToModal = function(index) {
                                const track = document.getElementById('part-img-track');
                                if (!track) return;
                                const total = track.children.length;
                                window._partImgCurrentModal = Math.max(0, Math.min(index, total - 1));
                                track.style.transform = `translateX(-${window._partImgCurrentModal * 100}%)`;
                                for (let i = 0; i < total; i++) {
                                    const dot = document.getElementById(`part-dot-modal-${i}`);
                                    if (!dot) continue;
                                    if (i === window._partImgCurrentModal) {
                                        dot.style.background = '#1D4064';
                                        dot.style.width = '20px';
                                    } else {
                                        dot.style.background = '#d1d5db';
                                        dot.style.width = '8px';
                                    }
                                }
                            };
                        }
                    }
                }
            } else {
                console.log('⚠️ No enrichment data found for:', label);
            }
            
        } catch (err) {
            console.error('❌ Enrich error:', err);
        }
    })();
}

function updateModalWithFullDetails(modal, fullDetails, label, price, stock, summary, vendor, productType, productUrl, esc) {
    const container = document.getElementById('full-details-container');
    if (!container) return;
    
    const images = fullDetails.images || [];
    const bodyHtml = fullDetails.bodyHtml || fullDetails.body_html || '';
    const variants = fullDetails.variants || [];
    const tags = fullDetails.tags || [];
    
    // Parse tables from bodyHtml
    let specsRows = [], interchangeRows = [];
    if (bodyHtml) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(bodyHtml, 'text/html');
        const tables = doc.querySelectorAll('table');
        
        if (tables.length > 0) {
            // First table = specs
            tables[0].querySelectorAll('tr').forEach(tr => {
                const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                if (cells.length >= 2) specsRows.push({ label: cells[0], value: cells[1] });
            });
            
            // Look for interchange table
            const interchangeIdx = bodyHtml.toLowerCase().indexOf('interchange');
            if (interchangeIdx !== -1 && tables.length > 1) {
                for (let i = 1; i < tables.length; i++) {
                    const tbl = tables[i];
                    const tblText = tbl.textContent.toLowerCase();
                    if (tblText.includes('brand') && tblText.includes('part')) {
                        tbl.querySelectorAll('tr').forEach(tr => {
                            const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                            if (cells.length >= 2) interchangeRows.push({ brand: cells[0], partNumber: cells[1] });
                        });
                        break;
                    }
                }
            }
        }
    }
    
    let html = '';
    
    // Image Gallery
    if (images.length > 1) {
        html += `
            <div style="margin-bottom:24px">
                <h3 style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0 0 12px 0">Images</h3>
                <div style="display:grid;grid-template-columns:repeat(auto-fit, minmax(150px, 1fr));gap:12px">
                    ${images.map(img => `
                        <div style="border-radius:10px;overflow:hidden;border:2px solid #e5e7eb">
                            <img src="${esc(img.src || img)}" style="width:100%;height:150px;object-fit:cover">
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    }
    
    // Specifications Table
    if (specsRows.length > 0) {
        html += `
            <div style="margin-bottom:24px">
                <h3 style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0 0 12px 0">Specifications</h3>
                <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-radius:10px;overflow:hidden">
                    ${specsRows.map(row => `
                        <tr style="border-bottom:1px solid #1e3a5f">
                            <td style="padding:10px 12px;background:#f9fafb;font-size:14px;color:#374151;font-weight:600;border-right:1px solid #1e3a5f;width:40%">${esc(row.label)}</td>
                            <td style="padding:10px 12px;background:#fff;font-size:14px;color:#1e3a5f">${esc(row.value)}</td>
                        </tr>
                    `).join('')}
                </table>
            </div>
        `;
    }
    
    // Interchange Data
    if (interchangeRows.length > 0) {
        html += `
            <div style="margin-bottom:24px">
                <h3 style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0 0 12px 0;background:#1e3a5f;color:#fff;padding:10px 16px;border-radius:10px 10px 0 0;text-align:center">Interchange Data</h3>
                <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-top:none;border-radius:0 0 10px 10px;overflow:hidden">
                    <tr style="background:#f9fafb;border-bottom:1px solid #1e3a5f">
                        <th style="padding:10px 12px;font-size:14px;font-weight:700;color:#1e3a5f;text-align:left">Brand</th>
                        <th style="padding:10px 12px;font-size:14px;font-weight:700;color:#1e3a5f;text-align:left">Part Number</th>
                    </tr>
                    ${interchangeRows.map(row => `
                        <tr style="border-bottom:1px solid #e5e7eb">
                            <td style="padding:10px 12px;font-size:14px;color:#374151;border-right:1px solid #1e3a5f">${esc(row.brand)}</td>
                            <td style="padding:10px 12px;font-size:14px;color:#1e3a5f;background:#fff;font-weight:600">${esc(row.partNumber)}</td>
                        </tr>
                    `).join('')}
                </table>
            </div>
        `;
    }
    
    // Compatibility Tags
    if (tags.length > 0) {
        html += `
            <div style="margin-bottom:24px">
                <h3 style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0 0 12px 0">Compatibility</h3>
                <div style="display:flex;flex-wrap:wrap;gap:8px">
                    ${tags.slice(0, 30).map(tag => `
                        <span style="background:#f9fafb;padding:6px 12px;border-radius:8px;border:1px solid #1e3a5f;font-size:13px;color:#1e3a5f">${esc(tag)}</span>
                    `).join('')}
                </div>
            </div>
        `;
    }
    
    // Variants
    if (variants.length > 1) {
        html += `
            <div>
                <h3 style="font-size:16px;font-weight:700;color:#1e3a5f;margin:0 0 12px 0">Available Options</h3>
                <div style="display:grid;gap:8px">
                    ${variants.map(v => `
                        <div style="display:flex;justify-content:space-between;align-items:center;padding:10px 14px;background:#f9fafb;border-radius:8px;border:1px solid #e5e7eb">
                            <span style="font-size:14px;color:#1e3a5f;font-weight:500">${esc(v.title || v.name || 'Option')}</span>
                            <span style="font-size:14px;font-weight:700;color:#1D4064">$${parseFloat(v.price || 0).toFixed(2)}</span>
                        </div>
                    `).join('')}
                </div>
            </div>
        `;
    }
    
    container.innerHTML = html;
}
// Part Summary Modal
function openPartSummaryModal(summaryText) {
    const modal = document.createElement('div');
    modal.className = 'cp-modal-overlay';
    modal.style.cssText = 'position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.5);display:flex;align-items:center;justify-content:center;z-index:9999;';
    modal.innerHTML = `
        <div style="background:#fff;border-radius:16px;padding:20px;width:85%;max-width:500px;box-shadow:0 4px 24px rgba(0,0,0,0.15);">
            <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px;padding-bottom:12px;border-bottom:1px solid #dde3e8">
                <span style="font-size:18px;font-weight:600;color:#1D4064">Summary</span>
                <button onclick="this.closest('.cp-modal-overlay').remove()" style="background:none;border:none;cursor:pointer;padding:4px">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#888" stroke-width="2">
                        <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                </button>
            </div>
            <div style="max-height:60vh;overflow-y:auto;padding:4px 0">
                <p style="font-size:15px;color:#2D2D2D;line-height:1.6">${summaryText.replace(/</g,'&lt;').replace(/>/g,'&gt;')}</p>
            </div>
        </div>
    `;
    modal.onclick = function(e) { if (e.target === modal) modal.remove(); };
    document.body.appendChild(modal);
}

async function viewPartDetails(partId) {
    console.log('🔍 viewPartDetails called with partId:', partId);
    
    // ── Find part in current tab's results ──
    let currentParts = [];
    if (state.activeTab === 'search') {
        if (state.searchTab === 'part') {
            currentParts = state.partSearch.results || [];
        } else {
            currentParts = state.searchVehicleParts || [];
        }
    } else if (state.activeTab === 'vin') {
        currentParts = state.vehicleParts || [];
    }
    
    console.log('📦 Searching in', currentParts.length, 'parts');
    
    const part = currentParts.find((p, idx) =>
        String(p.id || p.productId || p._id || `part-${idx}`) === String(partId)
    );
    
    if (!part) {
        console.error('❌ Part not found for ID:', partId);
        showToast('Part details not found');
        return;
    }
    
    // 🔑 DEBUG: Log ALL fields on the part object
    console.log('✅ Part found - ALL FIELDS:', Object.keys(part));
    console.log('✅ Part data sample:', JSON.stringify(part, null, 2).slice(0, 500) + '...');
    
    // Try EVERY possible identifier field (case-insensitive)
    const possibleIds = [
        part.partNumber, part.part_number, part.part,
        part.sku, part.Sku, part.SKU,
        part.name, part.Name, part.productName,
        part.title, part.Title,
        part.handle, part.Handle,
        part.id, part.productId, part._id,
        part.shopify?.id, part.shopify?.handle,
        part.product_id, part.code, part.itemNumber
    ].filter(v => v && String(v).trim() !== '' && String(v).toLowerCase() !== 'part').map(String);
    
    // Remove duplicates
    const uniqueIds = [...new Set(possibleIds)];
    
    // Primary label for display
    const label = uniqueIds[0] || partId;
    // Search terms for API calls
    const searchTerms = uniqueIds.length > 0 ? uniqueIds : [partId];
    
    console.log('🏷️ Using label:', label);
    console.log('🔍 Search terms for API:', searchTerms);
    
    // Show basic modal first with available data
    state.partDetails = part;
    state.partDetailsReturnTab = state.activeTab;
    state.activeTab = 'partDetails';
    patchContent();
    
    // If we have no usable identifier, show fallback message
    if (!uniqueIds.length) {
        console.warn('⚠️ No valid identifier found on part object');
        console.log('💡 Available fields:', Object.keys(part).filter(k => 
            ['partNumber','part_number','part','sku','name','title','handle','id','productId','code'].includes(k.toLowerCase())
        ));
        showToast('Part details limited - contact support for full specs');
        return;
    }
    
    try {
        const token = localStorage.getItem('token');
        
        // ── Step 1: Fetch from warehouse (try multiple identifiers) ──
        let warehouseItem = null;
        for (const term of searchTerms.slice(0, 3)) {
            try {
                const wRes = await fetch(
                    `${BASE_URL}/vehicle/product-search-warehouse?term=${encodeURIComponent(term)}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token ? { Authorization: `Bearer ${token}` } : {})
                        },
                        credentials: 'include'
                    }
                );
                if (wRes.ok) {
                    const wData = await wRes.json();
                    const wList = Array.isArray(wData) ? wData : (wData.products || wData.data || []);
                    // Match by any identifier field
                    warehouseItem = wList.find(r => {
                        const rIds = [r.partNumber, r.part_number, r.part, r.sku, r.id, r.handle].filter(Boolean);
                        return rIds.some(id => String(id).toLowerCase() === term.toLowerCase());
                    }) || wList[0];
                    if (warehouseItem) {
                        console.log('✅ Found warehouse item with term:', term);
                        break;
                    }
                }
            } catch (e) {
                console.warn('⚠️ Warehouse fetch failed for term', term, ':', e);
            }
        }
        
        // ── Step 2: Fetch from /products (try multiple identifiers) ──
        let fullProduct = null;
        for (const term of searchTerms.slice(0, 3)) {
            try {
                const pRes = await fetch(`${BASE_URL}/products?search=${encodeURIComponent(term)}&limit=10`, {
                    headers: {
                        'Content-Type': 'application/json',
                        ...(token ? { Authorization: `Bearer ${token}` } : {})
                    },
                    credentials: 'include'
                });
                if (pRes.ok) {
                    const pData = await pRes.json();
                    const pList = Array.isArray(pData) ? pData : (pData.data || pData.products || []);
                    
                    fullProduct = pList.find(p => {
                        const pIds = [p.title, p.handle, p.sku, p.partNumber, p.id, p.name].filter(Boolean);
                        return pIds.some(id => String(id).toLowerCase() === term.toLowerCase());
                    }) || pList[0];
                    
                    if (fullProduct) {
                        console.log('✅ Found full product with term:', term);
                        break;
                    }
                }
            } catch (e) {
                console.warn('⚠️ Products fetch failed for term', term, ':', e);
            }
        }
        
        // ── Step 3: Merge data ──
        const mergedImages = fullProduct?.images?.length
            ? fullProduct.images
            : (part.shopify?.images || part.images || []);
            
        const mergedVariants = fullProduct?.variants?.length
            ? fullProduct.variants
            : (part.shopify?.variants || part.variants || []);
        
        const mergedStock = part.stock ?? part.availableQty ?? warehouseItem?.stock ?? warehouseItem?.availableQty ?? fullProduct?.variants?.[0]?.inventoryQuantity ?? null;
        const mergedPrice = warehouseItem?.price ?? part.price ?? (fullProduct?.variants?.[0]?.price ? parseFloat(fullProduct.variants[0].price) : null);
        
        const mergedBodyHtml = fullProduct?.bodyHtml || fullProduct?.body_html || part.shopify?.bodyHtml || part.shopify?.body_html || part.bodyHtml || part.body_html || warehouseItem?.bodyHtml || warehouseItem?.body_html || '';
        
        console.log('📊 Merge results:', {
            bodyHtmlLength: mergedBodyHtml.length,
            hasTable: /<table/i.test(mergedBodyHtml),
            imagesCount: mergedImages.length,
            hasWarehouseData: !!warehouseItem,
            hasFullProduct: !!fullProduct
        });
        
        state.partDetails = {
            ...part,
            partNumber: label,
            vendor: fullProduct?.vendor || warehouseItem?.vendor || part.vendor || '',
            productType: fullProduct?.productType || fullProduct?.product_type || part.productType || '',
            tags: fullProduct?.tags || part.tags || [],
            image: mergedImages[0]?.src || mergedImages[0] || part.image || null,
            price: mergedPrice,
            stock: mergedStock,
            summary: warehouseItem?.summary || part.summary || null,
            notes: warehouseItem?.notes || part.notes || null,
            images: mergedImages,
            shopify: {
                ...(part.shopify || {}),
                bodyHtml: mergedBodyHtml,
                body_html: mergedBodyHtml,
                images: mergedImages,
                variants: mergedVariants,
                vendor: fullProduct?.vendor || part.shopify?.vendor || '',
                productType: fullProduct?.productType || part.shopify?.productType || '',
                tags: fullProduct?.tags || part.shopify?.tags || [],
            },
        };
        
        patchContent();
        
    } catch (err) {
        console.warn('❌ Could not enrich part details:', err);
    }
}
// Toast notification helper
function showToast(msg) {
    let toast = document.getElementById('cp-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.id = 'cp-toast';
        toast.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);background:#1a2a2a;color:#fff;padding:12px 24px;border-radius:10px;font-size:14px;z-index:9999;transition:transform 0.3s ease;white-space:nowrap;';
        document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.transform = 'translateX(-50%) translateY(0)';
    setTimeout(() => { toast.style.transform = 'translateX(-50%) translateY(80px)'; }, 2500);
}

// ── CHANGED: was document.addEventListener('DOMContentLoaded', async function() { ──
(async function () {
  const yearSelect = document.getElementById('yearSelect');
  const makeSelect = document.getElementById('makeSelect');
  const modelSelect = document.getElementById('modelSelect');
  const submodelSelect = document.getElementById('submodelSelect');
  const engineSelect = document.getElementById('engineSelect');
  const positionSelect = document.getElementById('positionSelect');
  const resultsContainer = document.getElementById('results');

  // Guard: if elements don't exist on page, stop
  if (!yearSelect) return;

  const apiUrl = 'https://data.usconvertors.com/search.php';

 window.fetchOptions = async function(action, params, selectElement, label, vinValue) {
  try {
    const response = await fetch(`${apiUrl}?action=${action}&${new URLSearchParams(params)}`);
    const data = await response.json();
    console.log(data.data);
    if (data.success) {
      // ── Year fix: merge generated years with API response ──
      if (action === 'get_years') {
        const START_YEAR = 1975;
        const currentYear = new Date().getFullYear();
        const generatedYears = [];
        for (let y = currentYear; y >= START_YEAR; y--) {
          generatedYears.push({ id: y, options: y });
        }
        // Merge: generated takes priority, API fills extras
        const apiIds = new Set((data.data || []).map(i => String(i.id)));
        const merged = [
          ...generatedYears,
          ...(data.data || []).filter(i => !apiIds.has(String(i.id)) || !generatedYears.find(g => String(g.id) === String(i.id)))
        ];
        // Remove duplicates, sort descending
        const seen = new Set();
        const unique = merged.filter(i => {
          const k = String(i.id);
          if (seen.has(k)) return false;
          seen.add(k);
          return true;
        });
        updateSelectOptions(selectElement, unique, label);
      } else {
        updateSelectOptions(selectElement, data.data, label);
      }
    } else {
      handleError(`Error fetching options: ${data.error}`);
    }
  } catch (error) {
    handleError('Error fetching options');
  }
}


  function updateSelectOptions(selectElement, options, label) {
    selectElement.innerHTML = '<option value="">Select a ' + label + '</option>';
    options.forEach((item) => {
      const option = document.createElement('option');
      option.value = item.id || item.options;
      option.textContent = item.options;
      selectElement.appendChild(option);
    });
  }

  function handleError(message) {
    console.error(message);
    alert(message);
  }

  function toggleVisibility(element, isVisible) {
    element.style.display = isVisible ? 'inline-block' : 'none';
    var parentElement = element.parentElement;
    parentElement.style.display = isVisible ? 'inline-block' : 'none';
  }

  window.handleYearChange = async function(yearValue) {
    const selectedYear = yearSelect.value;
    if (selectedYear) {
      makeSelect.innerHTML = '<option value="">Select a Make</option>';
      modelSelect.innerHTML = '<option value="">Select a Model</option>';
      await fetchOptions('get_makes', { year: selectedYear }, makeSelect, 'Make');
      resetSelects(['year']);
    } else {
      resetAll();
    }
  }

  window.handleMakeChange = async function(makeValue) {
    const selectedMake = makeSelect.value;
    const selectedYear = yearSelect.value;
    if (selectedMake && selectedYear) {
      modelSelect.innerHTML = '<option value="">Select a Model</option>';
      await fetchOptions('get_models', { make: selectedMake, year: selectedYear }, modelSelect, 'Model');
      resetSelects(['year', 'make', 'model']);
    } else {
      resetSelects(['year', 'make']);
    }
  }

  window.handleModelChange = async function(modelValue) {
    const modelSelect = document.getElementById('modelSelect');
    const makeSelect = document.getElementById('makeSelect');
    const yearSelect = document.getElementById('yearSelect');
    
    const selectedModel = modelSelect.value;
    const selectedMake = makeSelect.value;
    const selectedYear = yearSelect.value;
    
    if (selectedModel && selectedMake && selectedYear) {
        await fetchSubmodelsOrEngines(selectedModel, selectedMake, selectedYear);
    } else {
        resetSelects(['year', 'make', 'model']);
    }
  }

  async function fetchSubmodelsOrEngines(model, make, year) {
    try {
      const submodelUrl = `${apiUrl}?action=get_submodels&make=${make}&year=${year}&model=${model}`;
      const submodelResponse = await fetch(submodelUrl);
      const submodelData = await submodelResponse.json();

      if (submodelData.success) {
        if (submodelData.data.length > 0) {
          fetchOptions('get_submodels', { make, year, model }, submodelSelect, 'Submodel');
          resetSelects();
          toggleVisibility(submodelSelect, true);
        } else {
          toggleVisibility(submodelSelect, false);
          resetSelects();
          await fetchEnginesOrBody(model, make, year);
        }
      } else {
        handleError(`Error fetching submodels: ${submodelData.error}`);
        resetSelects();
      }
    } catch (error) {
      handleError('Error fetching submodels');
      resetSelects();
    }
  }

  async function fetchEnginesOrBody() {
    year = yearSelect.value;
    model = modelSelect.value;
    make = makeSelect.value;

    try {
      const selectedSubmodel = submodelSelect.value;
      let engineUrl = `${apiUrl}?action=get_engines&make=${make}&year=${year}&model=${model}`;
      if (selectedSubmodel) engineUrl += `&submodel=${selectedSubmodel}`;

      const engineResponse = await fetch(engineUrl);
      const engineData = await engineResponse.json();

      if (engineData.success) {
        if (engineData.data.length > 0) {
          fetchOptions('get_engines', { make, year, model, submodel: selectedSubmodel }, engineSelect, 'Engine');
          resetSelects(['submodel', 'body']);
          toggleVisibility(engineSelect, true);
          toggleVisibility(bodySelect, false);
        } else {
          toggleVisibility(engineSelect, false);
          await fetchBodyOrPositions();
        }
      } else {
        handleError(`Error fetching engines 1: ${engineData.error}`);
        toggleVisibility(engineSelect, false);
        resetSelects(['body']);
      }
    } catch (error) {
      handleError('Error fetching engines 2');
      toggleVisibility(engineSelect, false);
      resetSelects(['body']);
    }
  }

  async function fetchBodyOrPositions() {
    year = yearSelect.value;
    model = modelSelect.value;
    make = makeSelect.value;

    try {
      const selectedSubmodel = submodelSelect.value;
      const selectedEngine = engineSelect.value;

      let bodyUrl = `${apiUrl}?action=get_body&make=${make}&year=${year}&model=${model}`;
      if (selectedSubmodel) bodyUrl += `&submodel=${selectedSubmodel}`;
      if (selectedEngine) bodyUrl += `&engine=${selectedEngine}`;

      const bodyResponse = await fetch(bodyUrl);
      const bodyData = await bodyResponse.json();

      if (bodyData.success) {
        if (bodyData.data.length > 0) {
          fetchOptions(
            'get_body',
            { make, year, model, submodel: selectedSubmodel, engine: selectedEngine },
            bodySelect,
            'Body Type'
          );
          resetSelects(['submodel', 'body', 'engine', 'position']);
          toggleVisibility(bodySelect, true);
          toggleVisibility(positionSelect, false);
        } else {
          toggleVisibility(bodySelect, false);
          await fetchPositions(model, make, year);
        }
      } else {
        handleError(`Error fetching body types: ${bodyData.error}`);
        toggleVisibility(bodySelect, false);
        resetSelects(['position']);
      }
    } catch (error) {
      handleError('Error fetching body types');
      toggleVisibility(bodySelect, false);
      resetSelects(['position']);
    }
  }

  async function fetchPositions() {
    const selectedSubmodel = submodelSelect.value;
    const selectedEngine = engineSelect.value;
    const selectedBody = bodySelect.value;
    year = yearSelect.value;
    model = modelSelect.value;
    make = makeSelect.value;

    let url = `${apiUrl}?action=get_positions&make=${make}&year=${year}&model=${model}`;
    if (selectedSubmodel) url += `&submodel=${selectedSubmodel}`;
    if (selectedEngine) url += `&engine=${selectedEngine}`;
    if (selectedBody) url += `&ebody=${selectedBody}`;

    try {
      const response = await fetch(url);
      const data = await response.json();

      if (data.success) {
        if (data.data.length > 0) {
          fetchOptions(
            'get_positions',
            { make, year, model, submodel: selectedSubmodel, engine: selectedEngine, body: selectedBody },
            positionSelect,
            'Position'
          );
          toggleVisibility(positionSelect, true);
        } else {
          toggleVisibility(positionSelect, false);
          fetchParts();
        }
      } else {
        handleError(`Error fetching positions: ${data.error}`);
        toggleVisibility(positionSelect, false);
      }
    } catch (error) {
      handleError('Error fetching positions');
      toggleVisibility(positionSelect, false);
    }
  }

  async function fetchParts() {
    const selectedPosition = positionSelect.value;
    const selectedEngine = engineSelect.value;
    const selectedSubmodel = submodelSelect.value;
    const selectedModel = modelSelect.value;
    const selectedBody = bodySelect.value;

    if (selectedModel) {
      const response = await fetch(
        `${apiUrl}?action=get_parts` +
          `&make=${encodeURIComponent(makeSelect.value)}` +
          `&year=${encodeURIComponent(yearSelect.value)}` +
          `&model=${encodeURIComponent(selectedModel)}` +
          `${selectedSubmodel ? `&submodel=${encodeURIComponent(selectedSubmodel)}` : ''}` +
          `${selectedEngine ? `&engine=${encodeURIComponent(selectedEngine)}` : ''}` +
          `${selectedBody ? `&body=${encodeURIComponent(selectedBody)}` : ''}` +
          `${selectedPosition ? `&position=${encodeURIComponent(selectedPosition)}` : ''}`
      );

      const data = await response.json();
      if (data.success) {
        console.log(data);
        displayResults(data.data, data.aces);
      } else {
        handleError(`Error fetching parts: ${data.error}`);
        resultsContainer.innerHTML = 'No parts found.';
      }
    } else {
      resultsContainer.innerHTML = 'Please select a model.';
    }
  }

 // Replace your existing displayResults function with this:
function displayResults(parts) {
    if (!parts || parts.length === 0) {
        resultsContainer.innerHTML = `
            <div style="text-align:center;padding:40px;color:#888">
                <p style="font-weight:600">No parts found</p>
                <p style="font-size:14px">Try different filters</p>
            </div>`;
        return;
    }

    // 🔑 Store parts globally so openYmmPartDetail can access them
    window._vehicleParts = parts;

    const resultsHtml = parts.map((part, idx) => {
        const label = part.part || part.partNumber || part.sku || part.name || 'Part';
        const price = part.price != null ? parseFloat(part.price).toFixed(2) : null;
        const stock = part.stock != null ? parseInt(part.stock) : null;
        const image = part.image || part.imageUrl || null;
        const summary = part.summary || part.notes || null;
        const vendor = part.vendor || part.brand || null;
        
        const esc = (str) => String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
        
        return `
            <div class="result-item" style="cursor:pointer;padding:16px" 
                 data-part-idx="${idx}"
                 onclick="openYmmPartDetail(${idx})">
                <div style="display:flex;gap:14px;align-items:flex-start">
                    <div style="width:72px;height:72px;border-radius:8px;background:#f3f4f6;flex-shrink:0;overflow:hidden">
                        ${image ? `<img src="${esc(image)}" style="width:100%;height:100%;object-fit:cover">` : 
                        `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:#9ca3af">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/>
                            </svg>
                        </div>`}
                    </div>
                    <div style="flex:1;min-width:0">
                        <p style="font-weight:600;font-size:15px;color:#1D4064;margin:0 0 4px 0;line-height:1.3">${esc(label)}</p>
                        ${vendor ? `<p style="font-size:12px;color:#6b7280;margin:0 0 6px 0">Brand: ${esc(vendor)}</p>` : ''}
                        <div style="display:flex;align-items:center;gap:12px;flex-wrap:wrap">
                            ${price != null ? `<span style="font-size:16px;font-weight:700;color:#1D4064">$${price}</span>` : ''}
                            ${stock != null ? `<span style="font-size:12px;color:${stock > 0 ? '#1d9e75' : '#e24b4a'}">${stock > 0 ? `${stock} in stock` : 'Out of stock'}</span>` : ''}
                        </div>
                        ${summary ? `<p style="font-size:13px;color:#6b7280;line-height:1.4;margin-top:10px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden">${esc(summary)}</p>` : ''}
                    </div>
                </div>
            </div>
        `;
    }).join('');

    resultsContainer.innerHTML = `<div class="results-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(300px,1fr));gap:16px">${resultsHtml}</div>`;
    document.getElementById('results-header').style.display = 'block';
}

  function resetSelects(except = []) {
    const selects = {
      submodel: submodelSelect,
      engine: engineSelect,
      position: positionSelect,
      body: bodySelect,
    };
    console.log(except);
    console.log(selects);
    Object.keys(selects).forEach((key) => {
      if (!except.includes(key)) {
        selects[key].innerHTML = `<option value="">Select a ${key}</option>`;
        toggleVisibility(selects[key], false);
      }
    });
  }

  function resetAll() {
    yearSelect.innerHTML = '<option value="">Select a year</option>';
    makeSelect.innerHTML = '<option value="">Select a make</option>';
    modelSelect.innerHTML = '<option value="">Select a model</option>';
    resetSelects(['year']);
  }

  // Initial fetch for year options
  await fetchOptions('get_years', {}, yearSelect, 'Year');

  yearSelect.addEventListener('change', handleYearChange);
  makeSelect.addEventListener('change', handleMakeChange);
  modelSelect.addEventListener('change', handleModelChange);
  submodelSelect.addEventListener('change', fetchEnginesOrBody);
  engineSelect.addEventListener('change', fetchBodyOrPositions);
  bodySelect.addEventListener('change', fetchPositions);
  positionSelect.addEventListener('change', fetchParts);

// ── CHANGED: was }); ──
})();

window.openYmmPartDetail = async function(idx) {
    const part = window._vehicleParts[idx];
    if (!part) return;

    const label = part.part || part.partNumber || part.sku || part.name || part.title || part.label || '';
    const BASE_URL = 'https://api.exhaustexpert.com';
    const esc = (s) => String(s || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

    const existing = document.getElementById('ymm-detail-modal');
    if (existing) existing.remove();

    if (!document.getElementById('ymm-spin-style')) {
        const style = document.createElement('style');
        style.id = 'ymm-spin-style';
       style.textContent = `
            @keyframes ymmSpin { to { transform: rotate(360deg); } }
            #ymm-detail-modal * { box-sizing: border-box; }
            #ymm-detail-modal { font-family: "DM Sans", -apple-system, BlinkMacSystemFont, sans-serif; }
            .ymm-modal-inner {
                background: #fff;
                border-radius: 16px;
                width: 100%;
                max-width: 680px;
                height: 88vh;
                overflow: hidden;
                position: relative;
                display: flex;
                flex-direction: column;
            }
            .ymm-modal-inner::-webkit-scrollbar { width: 6px; }
            .ymm-modal-inner::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 8px; }
            .ymm-modal-inner::-webkit-scrollbar-thumb { background: #a0b8cc; border-radius: 8px; }
        `;
        document.head.appendChild(style);
    }

    const modal = document.createElement('div');
    modal.id = 'ymm-detail-modal';
    modal.style.cssText = `
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0,0,0,0.65);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        padding: 20px;
    `;

    modal.innerHTML = `<div class="ymm-modal-inner"><div style="padding:40px;display:flex;flex-direction:column;align-items:center;justify-content:center;flex:1"><div style="width:36px;height:36px;border:3px solid #e0e9f2;border-top-color:#1D4064;border-radius:50%;animation:ymmSpin 0.7s linear infinite;margin-bottom:16px"></div><p style="color:#888;font-size:14px;margin:0">Loading part details…</p></div></div>`;

    modal.onclick = (e) => { if (e.target === modal) modal.remove(); };
    document.body.appendChild(modal);

    try {
        const token = localStorage.getItem('token');

        let warehouseItem = null;
        if (label.length >= 3) {
            try {
                const wRes = await fetch(
                    `${BASE_URL}/vehicle/product-search-warehouse?term=${encodeURIComponent(label)}`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token ? { Authorization: `Bearer ${token}` } : {})
                        },
                        credentials: 'include'
                    }
                );
                if (wRes.ok) {
                    const wData = await wRes.json();
                    const wList = Array.isArray(wData) ? wData : (wData.products || wData.data || []);
                    warehouseItem = wList.find(r =>
                        (r.partNumber || r.sku || r.part || '').toLowerCase() === label.toLowerCase()
                    ) || wList[0];
                }
            } catch (e) {
                console.warn('Warehouse fetch failed:', e);
            }
        }

        let fullProduct = null;
        try {
            const searchTerms = [label, part.handle].filter(Boolean);
            for (const term of searchTerms) {
                const pRes = await fetch(
                    `${BASE_URL}/products?search=${encodeURIComponent(term)}&limit=10`,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            ...(token ? { Authorization: `Bearer ${token}` } : {})
                        },
                        credentials: 'include'
                    }
                );
                if (pRes.ok) {
                    const pData = await pRes.json();
                    const pList = Array.isArray(pData) ? pData : (pData.data || pData.products || []);
                    fullProduct =
                        pList.find(p => (p.title || '').toLowerCase() === label.toLowerCase()) ||
                        pList.find(p => (p.handle || '').toLowerCase() === label.toLowerCase()) ||
                        pList.find(p => {
                            const skus = [p.sku, p.partNumber, ...(p.variants || []).map(v => v.sku)].filter(Boolean);
                            return skus.some(s => s.toLowerCase() === label.toLowerCase());
                        }) ||
                        pList[0];
                    if (fullProduct) break;
                }
            }
        } catch (e) {
            console.warn('Products fetch failed:', e);
        }

        const bodyHtml = fullProduct?.bodyHtml || fullProduct?.body_html || '';
        const images = fullProduct?.images || [];
        const variants = fullProduct?.variants || [];
        const price = warehouseItem?.price ?? part.price ?? (variants[0]?.price ? parseFloat(variants[0].price) : null);
        const stock = warehouseItem?.stock ?? warehouseItem?.availableQty ?? part.stock ?? variants[0]?.inventoryQuantity ?? null;
        const vendor = fullProduct?.vendor || warehouseItem?.vendor || part.vendor || part.brand || null;
        const tags = fullProduct?.tags || [];
        const productType = fullProduct?.productType || fullProduct?.product_type || null;

        const imageList = images.length > 0
            ? images.map(img => typeof img === 'string' ? img : (img.src || img.url || '')).filter(Boolean)
            : (part.image ? [part.image] : []);

        let specsRows = [], interchangeRows = [];
        if (bodyHtml) {
            const parser = new DOMParser();
            const doc = parser.parseFromString(bodyHtml, 'text/html');
            const tables = doc.querySelectorAll('table');
            if (tables.length > 0) {
                tables[0].querySelectorAll('tr').forEach(tr => {
                    const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                    if (cells.length >= 2 && (cells[0] || cells[1])) {
                        specsRows.push({ label: cells[0], value: cells[1] });
                    }
                });
                for (let i = 1; i < tables.length; i++) {
                    const tbl = tables[i];
                    if (tbl.textContent.toLowerCase().includes('brand') && tbl.textContent.toLowerCase().includes('part')) {
                        tbl.querySelectorAll('tr').forEach(tr => {
                            const cells = Array.from(tr.querySelectorAll('td, th')).map(td => td.textContent.trim());
                            if (cells.length >= 2) interchangeRows.push({ brand: cells[0], partNumber: cells[1] });
                        });
                        break;
                    }
                }
            }
        }

        function stripHtml(html) {
            if (!html) return '';
            return html
                .replace(/<table[^>]*>[\s\S]*?<\/table>/gi, '')
                .replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n')
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&')
                .replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"')
                .replace(/\n{3,}/g, '\n').trim();
        }

        const summary = warehouseItem?.summary || part.summary || null;
        const description = summary || stripHtml(bodyHtml) || part.notes || '';
        const inStock = stock != null && stock > 0;
        const modalId = `ymm-img-${Date.now()}`;

       modal.querySelector('.ymm-modal-inner').innerHTML = `
            <div style="display:flex;align-items:center;justify-content:space-between;
                        padding:16px 20px;border-bottom:1px solid #eaeef2;
                        background:#FBFBFE;border-radius:16px 16px 0 0;
                        flex-shrink:0">
                <h2 style="font-size:15px;font-weight:700;color:#1e3a5f;margin:0;
                           flex:1;padding-right:12px;overflow:hidden;
                           text-overflow:ellipsis;white-space:nowrap">${esc(label)}</h2>
                <button onclick="document.getElementById('ymm-detail-modal').remove()"
                        style="background:none;border:none;cursor:pointer;padding:6px;
                               border-radius:8px;color:#888;display:flex;align-items:center;flex-shrink:0">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5">
                        <path d="M18 6L6 18M6 6l12 12"/>
                    </svg>
                </button>
            </div>

            <div style="padding:20px;overflow-y:auto;flex:1">

                ${imageList.length > 1 ? `
                    <div style="width:100%;margin-bottom:20px;border-radius:12px;
                                background:#f9fafb;overflow:hidden">
                        <div id="${modalId}-track"
                             style="display:flex;transition:transform 0.35s cubic-bezier(0.4,0,0.2,1)">
                            ${imageList.map((src) => `
                                <div style="min-width:100%;height:240px;display:flex;
                                            align-items:center;justify-content:center;background:#f9fafb">
                                    <img src="${esc(src)}"
                                         style="max-width:100%;max-height:240px;object-fit:contain;display:block"
                                         onerror="this.parentElement.style.display='none'">
                                </div>
                            `).join('')}
                        </div>
                        <div style="display:flex;justify-content:center;gap:6px;padding:8px 0">
                            ${imageList.map((_, i) => `
                                <button onclick="ymmGoTo('${modalId}',${i},${imageList.length})"
                                        id="${modalId}-dot-${i}"
                                        style="width:${i===0?'20px':'8px'};height:8px;border-radius:4px;
                                               border:none;background:${i===0?'#1D4064':'#d1d5db'};
                                               cursor:pointer;padding:0;transition:all 0.25s">
                                </button>
                            `).join('')}
                        </div>
                    </div>
                ` : imageList.length === 1 ? `
                    <div style="width:100%;height:240px;margin-bottom:20px;border-radius:12px;
                                background:#f9fafb;display:flex;align-items:center;
                                justify-content:center;overflow:hidden">
                        <img src="${esc(imageList[0])}"
                             style="max-width:100%;max-height:240px;object-fit:contain;display:block"
                             onerror="this.parentElement.style.background='#f3f4f6'">
                    </div>
                ` : ''}

                <div style="display:flex;flex-direction:column;gap:4px;margin-bottom:12px">
                    ${vendor ? `<span style="font-size:13px;color:#6b7280">Brand: ${esc(vendor)}</span>` : ''}
                    ${productType ? `<span style="font-size:13px;color:#6b7280">Type: ${esc(productType)}</span>` : ''}
                    ${part.qual ? `<span style="font-size:13px;color:#6b7280">Qualifier: ${esc(part.qual)}</span>` : ''}
                </div>

                ${(price != null || stock != null) ? `
                    <div style="display:grid;grid-template-columns:auto 1fr;
                                column-gap:16px;row-gap:8px;padding:14px 16px;
                                background:#f9fafb;border-radius:10px;margin-bottom:20px">
                        ${price != null ? `
                            <span style="font-size:13px;color:#6b7280;align-self:center">Price</span>
                            <span style="font-size:16px;font-weight:700;color:#1D4064">
                                $${parseFloat(price).toFixed(2)}
                            </span>
                        ` : ''}
                        <span style="font-size:13px;color:#6b7280;align-self:center">Availability</span>
                        <span style="font-size:13px;font-weight:600;color:${inStock ? '#1d9e75' : '#e24b4a'}">
                            ${inStock ? `✓ ${stock} in stock` : '✗ Out of stock'}
                        </span>
                    </div>
                ` : ''}

                ${description ? `
                    <div style="background:#f9fafb;border-radius:10px;padding:14px;margin-bottom:20px">
                        <h3 style="font-size:14px;font-weight:700;color:#1e3a5f;margin:0 0 8px">Details</h3>
                        <p style="font-size:14px;color:#6b7280;line-height:1.6;margin:0">${esc(description)}</p>
                    </div>
                ` : ''}

                ${specsRows.length > 0 ? `
                    <div style="margin-bottom:20px">
                        <h3 style="font-size:14px;font-weight:700;color:#1e3a5f;margin:0 0 10px">Specifications</h3>
                        <table style="width:100%;border-collapse:collapse;border:1px solid #d1d5db;border-radius:10px;overflow:hidden">
                            ${specsRows.map(row => `
                                <tr style="border-bottom:1px solid #e5e7eb">
                                    <td style="padding:10px 12px;background:#f9fafb;font-size:13px;color:#374151;font-weight:600;border-right:1px solid #d1d5db;width:42%">${esc(row.label)}</td>
                                    <td style="padding:10px 12px;background:#fff;font-size:13px;color:#1e3a5f">${esc(row.value)}</td>
                                </tr>
                            `).join('')}
                        </table>
                    </div>
                ` : ''}

                ${interchangeRows.length > 0 ? `
                    <div style="margin-bottom:20px">
                        <div style="background:#1e3a5f;padding:10px 16px;border-radius:10px 10px 0 0;text-align:center">
                            <span style="font-size:14px;font-weight:700;color:#fff">Interchange Data</span>
                        </div>
                        <table style="width:100%;border-collapse:collapse;border:1px solid #1e3a5f;border-top:none;border-radius:0 0 10px 10px;overflow:hidden">
                            <tr style="background:#f9fafb;border-bottom:1px solid #d1d5db">
                                <th style="padding:10px 12px;font-size:13px;font-weight:700;color:#1e3a5f;text-align:left;border-right:1px solid #d1d5db">Brand</th>
                                <th style="padding:10px 12px;font-size:13px;font-weight:700;color:#1e3a5f;text-align:left">Part Number</th>
                            </tr>
                            ${interchangeRows.map(row => `
                                <tr style="border-bottom:1px solid #e5e7eb">
                                    <td style="padding:10px 12px;font-size:13px;color:#374151;border-right:1px solid #d1d5db">${esc(row.brand)}</td>
                                    <td style="padding:10px 12px;font-size:13px;color:#1e3a5f;font-weight:600">${esc(row.partNumber)}</td>
                                </tr>
                            `).join('')}
                        </table>
                    </div>
                ` : ''}

                ${tags.length > 0 ? `
                    <div style="margin-bottom:20px">
                        <h3 style="font-size:14px;font-weight:700;color:#1e3a5f;margin:0 0 10px">Compatibility</h3>
                        <div style="display:flex;flex-wrap:wrap;gap:8px">
                            ${tags.slice(0, 20).map(tag => `
                                <span style="background:#f9fafb;padding:5px 10px;border-radius:8px;border:1px solid #1e3a5f;font-size:12px;color:#1e3a5f">${esc(tag)}</span>
                            `).join('')}
                        </div>
                    </div>
                ` : ''}

                <div style="margin-top:24px;padding-bottom:8px">
                    <button onclick="document.getElementById('ymm-detail-modal').remove()"
                            style="width:100%;padding:14px;background:#f1f1f1;border:none;
                                   border-radius:10px;cursor:pointer;font-weight:600;
                                   font-size:15px;font-family:inherit">
                        Close
                    </button>
                </div>
            </div>
        `;

        window.ymmGoTo = function(trackId, index, total) {
            const track = document.getElementById(trackId + '-track');
            if (!track) return;
            track.style.transform = `translateX(-${index * 100}%)`;
            for (let i = 0; i < total; i++) {
                const dot = document.getElementById(`${trackId}-dot-${i}`);
                if (!dot) continue;
                dot.style.background = i === index ? '#1D4064' : '#d1d5db';
                dot.style.width = i === index ? '20px' : '8px';
            }
        };

    } catch (err) {
        console.error('openYmmPartDetail error:', err);
        modal.querySelector('.ymm-modal-inner').innerHTML = `
            <div style="padding:24px">
                <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px">
                    <h2 style="font-size:16px;font-weight:700;color:#1D4064;margin:0">${esc(label)}</h2>
                    <button onclick="document.getElementById('ymm-detail-modal').remove()"
                            style="background:none;border:none;cursor:pointer;font-size:24px;color:#888">
                        &times;
                    </button>
                </div>
                ${part.image ? `<img src="${esc(part.image)}" style="width:100%;max-height:250px;object-fit:contain;border-radius:10px;margin-bottom:16px">` : ''}
                ${part.notes ? `<p style="color:#6b7280;font-size:14px;margin-bottom:16px">${esc(part.notes)}</p>` : ''}
                <button onclick="document.getElementById('ymm-detail-modal').remove()"
                        style="width:100%;padding:14px;background:#f1f1f1;border:none;
                               border-radius:10px;cursor:pointer;font-weight:600;font-size:15px">
                    Close
                </button>
            </div>
        `;
    }
};

// ── CHANGED: was document.addEventListener('DOMContentLoaded', function() { ──
(function() {
  var tabs = document.querySelectorAll('.tab-title');
  var panes = document.querySelectorAll('.tab-pane');

  // Guard: if elements don't exist on page, stop
  if (!tabs.length) return;

  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = this.getAttribute('data-tab');

      tabs.forEach(function(t) {
        t.classList.remove('active');
      });

      panes.forEach(function(pane) {
        if (pane.id === target) {
          pane.classList.add('active');
        } else {
          pane.classList.remove('active');
        }
      });

      this.classList.add('active');
    });
  });

// ── CHANGED: was }); ──
})();

/* ── CUSTOM DROPDOWN OVERLAY ── */
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .cp-ymm-select-wrap { position: relative; width: 100%; }
    .cp-ymm-trigger {
      width: 100%; height: 5rem;
      padding: 10px 20px 10px 16px;
      border: 1px solid #1D4064; border-radius: 0;
      font-size: 14px; color: #2D2D2D; background: #FBFBFE;
      cursor: pointer; display: flex; align-items: center;
      justify-content: space-between; user-select: none;
      transition: background 0.15s; box-sizing: border-box;
         outline: none !important;
    box-shadow: none !important;
    border: none !important;
    }
    .cp-ymm-trigger:hover { background: #E0E9F2; }
    .cp-ymm-trigger.open { box-shadow: 0 0 0 3px rgba(29,64,100,0.12); }
    .cp-ymm-trigger.disabled { background: #f5f5f5; cursor: not-allowed; opacity: 0.6; pointer-events: none; }
    .cp-ymm-trigger span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; flex: 1; }
    .cp-ymm-trigger span.ph { color: #999;font-size:16px; }
    .cp-ymm-arrow { flex-shrink:0; margin-left:8px; transition: transform 0.2s; color:#1D4064; }
    .cp-ymm-trigger.open .cp-ymm-arrow { transform: rotate(180deg); }
    .cp-ymm-dropdown {
      position: absolute; top: calc(100% + 2px); left: 0; right: 0;
      background: #fff; border: 1.5px solid #1D4064; border-radius: 4px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.10); z-index: 99999;
      max-height: 220px; overflow-y: auto; display: none;
    }
    .cp-ymm-dropdown.open { display: block; }
    .cp-ymm-option { padding: 10px 16px; font-size: 14px; color: #2D2D2D; cursor: pointer; background: #fff; transition: background 0.12s; }
    .cp-ymm-option:hover { background: #E0E9F2; color: #1D4064; }
    .cp-ymm-option.selected { background: #E0E9F2; color: #1D4064; font-weight: 600; }
    .cp-ymm-option.ph-opt { color: #999; }
    .cp-ymm-option.ph-opt:hover { background: #f8fafb; color: #999; }
    .cp-ymm-dropdown::-webkit-scrollbar { width: 6px; }
    .cp-ymm-dropdown::-webkit-scrollbar-track { background: #E0E9F2; border-radius: 8px; }
    .cp-ymm-dropdown::-webkit-scrollbar-thumb { background: #a0b8cc; border-radius: 8px; }
    .cp-ymm-dropdown::-webkit-scrollbar-thumb:hover { background: #7a9ab5; }
  `;
  document.head.appendChild(style);

  const FIELDS = [
    { id: 'yearSelect',     ph: 'Select a Year'     },
    { id: 'makeSelect',     ph: 'Select a Make'     },
    { id: 'modelSelect',    ph: 'Select a Model'    },
    { id: 'submodelSelect', ph: 'Select a Submodel' },
    { id: 'engineSelect',   ph: 'Select an Engine'  },
    { id: 'bodySelect',     ph: 'Select Body Type'  },
    { id: 'positionSelect', ph: 'Select a Position' },
  ];

  function closeAll() {
    document.querySelectorAll('.cp-ymm-dropdown.open').forEach(function(d) {
      d.classList.remove('open');
      var w = d.closest('.cp-ymm-select-wrap');
      if (w) w.querySelector('.cp-ymm-trigger').classList.remove('open');
    });
  }
  document.addEventListener('click', closeAll);

  function buildFor(select, ph) {
    var parent = select.parentElement;
    if (!parent) return;

    // Hide native select
    select.style.cssText = 'position:absolute!important;opacity:0!important;pointer-events:none!important;height:0!important;width:0!important;';

    // Remove old wrap
    var old = parent.querySelector('.cp-ymm-select-wrap');
    if (old) old.remove();

    var opts = Array.from(select.options).filter(function(o) { return o.value !== ''; });
    var selVal = select.value || '';
    var isDisabled = opts.length === 0;
    var displayText = selVal
      ? (select.options[select.selectedIndex] ? select.options[select.selectedIndex].text : selVal)
      : ph;

    var wrap = document.createElement('div');
    wrap.className = 'cp-ymm-select-wrap';
    wrap.innerHTML =
      '<div class="cp-ymm-trigger' + (isDisabled ? ' disabled' : '') + '">' +
        '<span class="' + (selVal ? '' : 'ph') + '">' + displayText + '</span>' +
        '<svg class="cp-ymm-arrow" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">' +
          '<polyline points="18 15 12 9 6 15"/>' +
        '</svg>' +
      '</div>' +
      '<div class="cp-ymm-dropdown">' +
        '<div class="cp-ymm-option ph-opt" data-val="">' + ph + '</div>' +
        opts.map(function(o) {
          return '<div class="cp-ymm-option' + (o.value === selVal ? ' selected' : '') + '" data-val="' + o.value.replace(/"/g, '&quot;') + '">' + o.text + '</div>';
        }).join('') +
      '</div>';

    parent.appendChild(wrap);

    var trigger  = wrap.querySelector('.cp-ymm-trigger');
    var dropdown = wrap.querySelector('.cp-ymm-dropdown');

    if (isDisabled) return;

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      var wasOpen = dropdown.classList.contains('open');
      closeAll();
      if (!wasOpen) {
        dropdown.classList.add('open');
        trigger.classList.add('open');
      }
    });

    dropdown.querySelectorAll('.cp-ymm-option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        var val  = this.dataset.val;
        var text = this.textContent.trim();

        var span = trigger.querySelector('span');
        if (val) { span.textContent = text; span.className = ''; }
        else      { span.textContent = ph;   span.className = 'ph'; }

        dropdown.querySelectorAll('.cp-ymm-option').forEach(function(o) { o.classList.remove('selected'); });
        if (val) this.classList.add('selected');

        closeAll();

        // This triggers year-make-model.js listeners directly
        select.value = val;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function watchSelect(select, ph) {
    buildFor(select, ph);
    new MutationObserver(function() {
      buildFor(select, ph);
    }).observe(select, { childList: true, subtree: true });

    // Watch parent show/hide
    var parentField = select.parentElement;
    if (parentField) {
      new MutationObserver(function() {
        buildFor(select, ph);
      }).observe(parentField, { attributes: true, attributeFilter: ['style'] });
    }
  }

  // Run after all existing JS has finished (years are already loaded by IIFE above)
  setTimeout(function() {
    FIELDS.forEach(function(f) {
      var select = document.getElementById(f.id);
      if (!select) return;
      watchSelect(select, f.ph);
    });
  }, 100);

})();

/* ── Category Custom Dropdown ── */
(function() {
  const style = document.createElement('style');
  style.textContent = `
    .cp-cat-wrap { position: relative; display: inline-block; }
    .cp-cat-trigger {
  height: 4.5rem;
  padding: 10px 16px;
  margin-left: 10px;
  border: 1px solid #1D4064;
  border-radius: 24px;
  font-size: 16px;
  color: #2D2D2D;
  background: #FBFBFE;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;
  transition: background 0.15s;
  box-sizing: border-box;
  min-width: 260px;
  gap: 10px;
}
    .cp-cat-trigger:hover { background: #E0E9F2; }
    .cp-cat-trigger.open { box-shadow: 0 0 0 3px rgba(29,64,100,0.12); }
    .cp-cat-trigger span.ph { color: #999; }.cp-cat-arrow {
    margin-left: auto;
    flex-shrink: 0;
    color: #1D4064;
    transition: transform 0.2s;
}
    .cp-cat-trigger.open .cp-cat-arrow { transform: rotate(180deg); }
    .cp-cat-dropdown {
      position: absolute; top: calc(100% + 4px); left: 10px; right: 0;
      background: #fff; border: 1.5px solid #1D4064; border-radius: 8px;
      box-shadow: 0 4px 16px rgba(0,0,0,0.10); z-index: 99999;
      max-height: 220px; overflow-y: auto; display: none; min-width: 260px;
    }
    .cp-cat-dropdown.open { display: block; }
    .cp-cat-option {
      padding: 10px 16px; font-size: 14px; color: #2D2D2D;
      cursor: pointer; background: #fff; transition: background 0.12s;
    }
    .cp-cat-option:hover { background: #E0E9F2; color: #1D4064; }
    .cp-cat-option.selected { background: #E0E9F2; color: #1D4064; font-weight: 600; }
    .cp-cat-option.ph-opt { color: #999; }
    .cp-cat-option.ph-opt:hover { background: #f8fafb; color: #999; }
    .cp-cat-dropdown::-webkit-scrollbar { width: 6px; }
    .cp-cat-dropdown::-webkit-scrollbar-track { background: #E0E9F2; border-radius: 8px; }
    .cp-cat-dropdown::-webkit-scrollbar-thumb { background: #a0b8cc; border-radius: 8px; }
    .cp-cat-dropdown::-webkit-scrollbar-thumb:hover { background: #7a9ab5; }
  `;
  document.head.appendChild(style);

  function buildCategoryDropdown(select) {
    if (!select) return;
    const parent = select.parentElement;
    if (!parent) return;

    // Hide native select
    select.style.cssText = 'position:absolute!important;opacity:0!important;pointer-events:none!important;height:0!important;width:0!important;';

    // Remove old wrap if exists
    const old = parent.querySelector('.cp-cat-wrap');
    if (old) old.remove();

    const opts = Array.from(select.options).filter(o => o.value !== '');
    const selVal = select.value || '';
    const ph = 'Select a Category';
    const displayText = selVal
      ? (select.options[select.selectedIndex]?.text || selVal)
      : ph;

    const wrap = document.createElement('div');
    wrap.className = 'cp-cat-wrap';
    wrap.innerHTML = `
      <div class="cp-cat-trigger">
        <span class="${selVal ? '' : 'ph'}">${displayText}</span>
        <svg class="cp-cat-arrow" width="16" height="16" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="18 15 12 9 6 15"/>
        </svg>
      </div>
      <div class="cp-cat-dropdown">
        <div class="cp-cat-option ph-opt" data-val="">${ph}</div>
        ${opts.map(o => `
          <div class="cp-cat-option${o.value === selVal ? ' selected' : ''}"
               data-val="${o.value.replace(/"/g,'&quot;')}">
            ${o.text}
          </div>`).join('')}
      </div>
    `;

    parent.appendChild(wrap);

    const trigger = wrap.querySelector('.cp-cat-trigger');
    const dropdown = wrap.querySelector('.cp-cat-dropdown');

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains('open');
      // Close all
      document.querySelectorAll('.cp-cat-dropdown.open').forEach(d => {
        d.classList.remove('open');
        d.closest('.cp-cat-wrap')?.querySelector('.cp-cat-trigger')?.classList.remove('open');
      });
      if (!wasOpen) {
        dropdown.classList.add('open');
        trigger.classList.add('open');
      }
    });

    dropdown.querySelectorAll('.cp-cat-option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        const val = this.dataset.val;
        const text = this.textContent.trim();

        const span = trigger.querySelector('span');
        if (val) { span.textContent = text; span.className = ''; }
        else      { span.textContent = ph;   span.className = 'ph'; }

        dropdown.querySelectorAll('.cp-cat-option').forEach(o => o.classList.remove('selected'));
        if (val) this.classList.add('selected');

        dropdown.classList.remove('open');
        trigger.classList.remove('open');

        // Fire native change → handleCategoryChange() triggers
        select.value = val;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  document.addEventListener('click', function() {
    document.querySelectorAll('.cp-cat-dropdown.open').forEach(d => {
      d.classList.remove('open');
      d.closest('.cp-cat-wrap')?.querySelector('.cp-cat-trigger')?.classList.remove('open');
    });
  });

  // Init after DOM ready
  function init() {
    const select = document.getElementById('categorySelect');
    if (!select) return;
    buildCategoryDropdown(select);

    // Watch for subcategorySelect too
    const subSelect = document.getElementById('subcategorySelect');
    if (subSelect) {
      buildSubcategoryDropdown(subSelect);
      new MutationObserver(function() {
        buildSubcategoryDropdown(subSelect);
      }).observe(subSelect, { childList: true });

      // Watch subcategoryGroup show/hide
      const subGroup = document.getElementById('subcategoryGroup');
      if (subGroup) {
        new MutationObserver(function() {
          buildSubcategoryDropdown(subSelect);
        }).observe(subGroup, { attributes: true, attributeFilter: ['style'] });
      }
    }
  }

  function buildSubcategoryDropdown(select) {
    if (!select) return;
    const parent = select.parentElement;
    if (!parent) return;

    select.style.cssText = 'position:absolute!important;opacity:0!important;pointer-events:none!important;height:0!important;width:0!important;';

    const old = parent.querySelector('.cp-cat-wrap');
    if (old) old.remove();

    const opts = Array.from(select.options).filter(o => o.value !== '');
    const selVal = select.value || '';
    const ph = 'Select a Subcategory';
    const displayText = selVal
      ? (select.options[select.selectedIndex]?.text || selVal)
      : ph;

    const wrap = document.createElement('div');
    wrap.className = 'cp-cat-wrap';
    wrap.innerHTML = `
      <div class="cp-cat-trigger" style="margin-left:0">
        <span class="${selVal ? '' : 'ph'}">${displayText}</span>
        <svg class="cp-cat-arrow" width="16" height="16" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="18 15 12 9 6 15"/>
        </svg>
      </div>
      <div class="cp-cat-dropdown" style="left:0">
        <div class="cp-cat-option ph-opt" data-val="">${ph}</div>
        ${opts.map(o => `
          <div class="cp-cat-option${o.value === selVal ? ' selected' : ''}"
               data-val="${o.value.replace(/"/g,'&quot;')}">
            ${o.text}
          </div>`).join('')}
      </div>
    `;

    parent.appendChild(wrap);

    const trigger = wrap.querySelector('.cp-cat-trigger');
    const dropdown = wrap.querySelector('.cp-cat-dropdown');

    trigger.addEventListener('click', function(e) {
      e.stopPropagation();
      const wasOpen = dropdown.classList.contains('open');
      document.querySelectorAll('.cp-cat-dropdown.open').forEach(d => {
        d.classList.remove('open');
        d.closest('.cp-cat-wrap')?.querySelector('.cp-cat-trigger')?.classList.remove('open');
      });
      if (!wasOpen) {
        dropdown.classList.add('open');
        trigger.classList.add('open');
      }
    });

    dropdown.querySelectorAll('.cp-cat-option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        const val = this.dataset.val;
        const text = this.textContent.trim();

        const span = trigger.querySelector('span');
        if (val) { span.textContent = text; span.className = ''; }
        else      { span.textContent = ph;   span.className = 'ph'; }

        dropdown.querySelectorAll('.cp-cat-option').forEach(o => o.classList.remove('selected'));
        if (val) this.classList.add('selected');

        dropdown.classList.remove('open');
        trigger.classList.remove('open');

        select.value = val;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

window.openVinScanner = function() {
  vinScanHandledRef = false;
  isScannerRunning = false;
  state.vinScannerOpen = true;
  patchVinModal();

  waitForElement('vin-scanner-container', 3000)
    .then(() => initHtml5QrCodeScanner())
    .catch((err) => console.error('Scanner container never appeared:', err));
};

function clearResults() {
  document.getElementById('results').innerHTML = '';
  document.getElementById('results-header').style.display = 'none';
}